var map = {
	"./add.svg": "5110",
	"./alipay.svg": "226f",
	"./awesome.svg": "2826",
	"./close.svg": "864a",
	"./date.svg": "a2bf",
	"./delete.svg": "a3dd",
	"./down.svg": "1a4e",
	"./download.svg": "039a",
	"./error.svg": "7518",
	"./eye.svg": "57fa",
	"./fast-back.svg": "19f3",
	"./fast-forward.svg": "cf2f",
	"./github.svg": "cda1",
	"./home.svg": "0331",
	"./info.svg": "b888",
	"./left.svg": "d6aa",
	"./loading.svg": "eede",
	"./phone.svg": "b470",
	"./right.svg": "6ffa",
	"./search.svg": "679a",
	"./settings.svg": "9c15",
	"./success.svg": "ce70",
	"./warning.svg": "0d95",
	"./wepay.svg": "9d57"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "f853";